import { render } from "./TrainingSkillSkillComponent.vue?vue&type=template&id=5cbb47c1&scoped=true"
import script from "./TrainingSkillSkillComponent.vue?vue&type=script&lang=js"
export * from "./TrainingSkillSkillComponent.vue?vue&type=script&lang=js"

import "./TrainingSkillSkillComponent.vue?vue&type=style&index=0&id=5cbb47c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbb47c1"]])

export default __exports__